import useDataFetcher, { UseDataFetcherReturn } from 'Hooks/Http/useDataFetcher';
import getBrandActivationsRequest, {
	GetBrandActivationsResponse,
} from 'Utils/Http/Requests/Brands/BrandActivations/GetBrandActivationsRequest';

const useFetchBrandActivations = (): UseDataFetcherReturn<GetBrandActivationsResponse> =>
	useDataFetcher(getBrandActivationsRequest);

export default useFetchBrandActivations;
